/* eslint sort-keys: "error" */
/* eslint-env es6 */

const AfsProductCareOnArgosFeatures = {
  ASK_QUESTION: true,
  ASK_TREVOR_ENABLED: false,
  ATT_MODAL_HIDE_CATEGORIES: false,
  ATT_MODAL_HIDE_EXTRAS: false,
  BASE_URL: 'www.argos.co.uk',
  BREADCRUMB: false,
  CATEGORY_EXPERIENCES_TEMPLATE_ENABLED: false,
  CNET: true,
  COMPARISON_ATTRIBUTES: false,
  COMPLETE_THE_LOOK: false,
  CUSTOMER_GENERATED_CONTENT: false,
  DESCRIPTION_CLASS: 'xs-12--none md-7--none xl-8--none',
  EMAIL_ME_BACK: {
    enabled: false
  },
  ENERGY_SAVING: false,
  ESSENTIAL_EXTRAS: true,
  FABLE_ATT: false,
  FEATURED_PRODUCTS: true,
  FREQUENTY_BROUHT_TOGETHER: true,
  FULFILMENT_PASS: {
    SHOW_PRODUCT_ELIGIBILITY: false,
    SHOW_PURCHASE_PASS: false
  },
  GO_IN_STORE: false,
  MEDIA_CLASS: 'xs-12--none md-7 xl-8',
  MEDIA_PORTRAIT: false,
  MONTHLY_PAYMENT_PLAN: true,
  NECTAR: true,
  PAYPAL_MESSAGING: true,
  PDP_V2_ENABLED: true,
  PRICING_CLASS: 'xs-12--none md-5--none xl-4--none',
  Q_AND_A: true,
  REVIEWS: false,
  REVIEWS_WRITE_REVIEW_ENABLED: false,
  SHOP_COLLECTION: false,
  SOLD_BY_ARGOS: false,
  SPECIFICATION_TABLE: false,
  STICKY_BAR: true,
  TEMPLATE_TYPE: 'AFS',
  WISHLIST: true
}

export default AfsProductCareOnArgosFeatures
